import { Skeleton, SkeletonProps, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useWidth } from "utils/helpers/use-is-mobile";

export type SkeletonTableColumnsType = {
  key: string;
};

type SkeletonTableProps = SkeletonProps & {
  columns: ColumnsType<SkeletonTableColumnsType>;
  rowCount?: number;
};

export default function SkeletonTable({
  loading = false,
  active = true,
  rowCount = 8,
  columns,
  children,
  className,
}: SkeletonTableProps): JSX.Element {
  const { isMobile } = useWidth();
  return loading && !isMobile ? (
    <Table
      rowKey="key"
      pagination={false}
      dataSource={[...Array(rowCount)].map((_, index) => ({
        key: `key${index}`,
      }))}
      columns={columns.map((column, index) => {
        return {
          ...column,
          key: index,
          render: function renderPlaceholder() {
            return (
              <Skeleton
                key={column.key}
                title
                active={active}
                paragraph={false}
                className={className}
              />
            );
          },
        };
      })}
    />
  ) : (
    <>{children}</>
  );
}
